

/// <reference path="FileURL.ts" />

// Generated class Asset_ManagedObject

class Asset_ManagedObject extends FileURL
{

    // Property: bundleIdentifier
    set bundleIdentifier(value:string) {
        this.setValueForKey(value, 'bundleIdentifier');
    }
    get bundleIdentifier():string {
        return this.valueForKey('bundleIdentifier');
    }
    set bundleIdentifierPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'bundleIdentifier');
    }
    get bundleIdentifierPrimitiveValue():string {
        return this.primitiveValueForKey('bundleIdentifier');
    }
}
